export enum TimelineSide {
    BEFORE = 'before',
    AFTER = 'after',
}

export interface TimelineEvent {
    text: string;
    date: Date;
    /** where to place the event in horizontal mode */
    side: TimelineSide;
    /** title of the event; falls back to date string if not provided */
    title?: string;
    /** offset to previous event; falls back to calculated offset based on date */
    offset?: number;
    /** whether event should break into a new stack in horizontal mode; defaults to true */
    breakStack?: boolean;
}

export enum TimelineDirection {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}

export const milestones: TimelineEvent[] = [
    {
        date: new Date('2012-02'),
        text: 'StudyDrive was founded',
        side: TimelineSide.BEFORE,
    },
    {
        date: new Date('2013-03'),
        text: 'First major university partnership established',
        side: TimelineSide.BEFORE,
    },
    {
        date: new Date('2015-05'),
        text: 'Expansion to multiple German universities',
        side: TimelineSide.AFTER,
    },
    {
        date: new Date('2017-01'),
        text: 'Launch of premium features',
        side: TimelineSide.AFTER,
    },
    {
        date: new Date('2018-05'),
        text: 'International expansion begins',
        side: TimelineSide.AFTER,
    },
    {
        date: new Date('2019-01'),
        text: 'Mobile app launch',
        side: TimelineSide.AFTER,
    },
    {
        date: new Date('2020-07'),
        text: 'Major platform update and redesign',
        side: TimelineSide.BEFORE,
        breakStack: true,
    },
    {
        date: new Date('2021-03'),
        text: 'Reached 1 million active users',
        side: TimelineSide.BEFORE,
    },
];
